// Leaf - Event - select_kit - Start

(function () {
    if (window.location.pathname !== '/products/restore-refillable-gel-toothpaste') return;
  
    function getProductData() {
      if (
        window.ShopifyAnalytics &&
        window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.meta.product
      ) {
        var p = window.ShopifyAnalytics.meta.product;
        var productName = null;
        if (p.variants && p.variants.length > 0 && p.variants[0].name) {
          var variantName = p.variants[0].name;
          var dashIdx = variantName.indexOf(' - ');
          productName = dashIdx !== -1 ? variantName.substring(0, dashIdx) : variantName;
        }
        return { product_id: p.id, product_name: productName };
      }
  
      var jsonLdEl = document.querySelector('script[type="application/ld+json"]');
      if (jsonLdEl) {
        try {
          var data = JSON.parse(jsonLdEl.textContent);
          if (data['@type'] === 'Product') {
            return { product_id: data.productID || data.sku || null, product_name: data.name || null };
          }
        } catch (e) {}
      }
  
      return { product_id: null, product_name: null };
    }
  
    function normalizeKitType(title) {
      return title
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_]/g, '');
    }
  
    function pushSelectKit(kitTitle, productData) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'select_kit',
        kit_type: normalizeKitType(kitTitle),
        product_id: productData.product_id,
        product_name: productData.product_name
      });
    }
  
    function init() {
      var productData = getProductData();
  
      document.addEventListener('change', function (e) {
        var input = e.target;
        if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return;
  
        // p_kit_component block: inputs rendered via p_kit_component.liquid
        if (input.dataset.kitSelectionInput === 'true') {
          var label = document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
          var titleEl = label && label.querySelector('.kit-selector__title');
          var kitTitle = titleEl ? titleEl.textContent.trim() : input.value;
          pushSelectKit(kitTitle, productData);
          return;
        }
  
        // variant-option--kit-selector snippet: inputs rendered via variant-option--kit-selector.liquid
        if (input.dataset.optionValue && input.closest('.kit-selector')) {
          pushSelectKit(input.dataset.optionValue, productData);
        }
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  
  // Leaf - Event - select_kit - End
  
  // Leaf - Event - select_flavour - Start
  
  (function () {
    if (window.location.pathname !== '/products/restore-refillable-gel-toothpaste') return;
  
    function getProductData() {
      if (
        window.ShopifyAnalytics &&
        window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.meta.product
      ) {
        var p = window.ShopifyAnalytics.meta.product;
        var productName = null;
        if (p.variants && p.variants.length > 0 && p.variants[0].name) {
          var variantName = p.variants[0].name;
          var dashIdx = variantName.indexOf(' - ');
          productName = dashIdx !== -1 ? variantName.substring(0, dashIdx) : variantName;
        }
        return { product_id: p.id, product_name: productName };
      }
  
      var jsonLdEl = document.querySelector('script[type="application/ld+json"]');
      if (jsonLdEl) {
        try {
          var data = JSON.parse(jsonLdEl.textContent);
          if (data['@type'] === 'Product') {
            return { product_id: data.productID || data.sku || null, product_name: data.name || null };
          }
        } catch (e) {}
      }
  
      return { product_id: null, product_name: null };
    }
  
    function normalizeFlavourName(value) {
      return value
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_]/g, '');
    }
  
    function isFlavourInput(input) {
      // Regular flavour cards live inside .option_values.modern-flavour
      if (input.closest('.option_values.modern-flavour')) return true;
      // The "Or choose" featured card (e.g. Mixed 3 Pack) sits in .modern-flavour__featured-wrap
      if (input.closest('.modern-flavour__featured-wrap')) return true;
      return false;
    }
  
    function init() {
      var productData = getProductData();
  
      document.addEventListener('change', function (e) {
        var input = e.target;
        if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return;
        if (!input.dataset.optionValue) return;
        if (!isFlavourInput(input)) return;
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'select_flavour',
          flavour_name: normalizeFlavourName(input.dataset.optionValue),
          product_id: productData.product_id,
          product_name: productData.product_name
        });
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  
  // Leaf - Event - select_flavour - End
  
  // Leaf - Event - select_plan - Start
  
  (function () {
    if (window.location.pathname !== '/products/restore-refillable-gel-toothpaste') return;
  
    function getProductData() {
      if (
        window.ShopifyAnalytics &&
        window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.meta.product
      ) {
        var p = window.ShopifyAnalytics.meta.product;
        return { product_id: p.id };
      }
  
      var jsonLdEl = document.querySelector('script[type="application/ld+json"]');
      if (jsonLdEl) {
        try {
          var data = JSON.parse(jsonLdEl.textContent);
          if (data['@type'] === 'Product') {
            return { product_id: data.productID || data.sku || null };
          }
        } catch (e) {}
      }
  
      return { product_id: null };
    }
  
    function normalizeValue(value) {
      return value
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_]/g, '');
    }
  
    function isOneTimeInput(input) {
      // selling_plan_only mode: id ends in -buy_once
      if (input.id && input.id.endsWith('-buy_once')) return true;
      // add_item mode: has no-subscription-input class
      if (input.classList.contains('no-subscription-input')) return true;
      return false;
    }
  
    function isSubscribeInput(input) {
      // selling_plan_only mode: id ends in -buy_plan
      if (input.id && input.id.endsWith('-buy_plan')) return true;
      // add_item mode: id ends in -sub but NOT -no-sub or -no-sub-{variantId}
      if (input.id && /-sub$/.test(input.id) && !/-no-sub/.test(input.id)) return true;
      return false;
    }
  
    function getPlanFrequency(input) {
      var wrapper = input.closest('.subscription-options-block');
      if (!wrapper) return 'na';
  
      // data-main-delivery-interval is the raw interval value (e.g. "Every 3 months")
      var interval = wrapper.dataset.mainDeliveryInterval;
      if (interval && interval.trim()) return normalizeValue(interval);
  
      // Fallback to the selling plan name stored in data-recurrence-label
      var recurrence = wrapper.dataset.recurrenceLabel;
      if (recurrence && recurrence.trim()) return normalizeValue(recurrence);
  
      return 'na';
    }
  
    function init() {
      var productData = getProductData();
  
      document.addEventListener('change', function (e) {
        var input = e.target;
        if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return;
        if (!input.closest('.subscription-options-block')) return;
  
        var planType, planFrequency;
  
        if (isOneTimeInput(input)) {
          planType = 'one_time';
          planFrequency = 'na';
        } else if (isSubscribeInput(input)) {
          planType = 'subscribe';
          planFrequency = getPlanFrequency(input);
        } else {
          return;
        }
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'select_plan',
          plan_type: planType,
          plan_frequency: planFrequency,
          product_id: productData.product_id
        });
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  
  // Leaf - Event - select_plan - End
  
  // Leaf - Event - select_variant - Start
  
  (function () {
    if (window.location.pathname !== '/products/restore-refillable-gel-toothpaste') return;
  
    function getProductId() {
      // Bottle product ID — lives on the upsell container, distinct from the refills product ID
      var upsellEl = document.querySelector('[data-upsell-for-kit]');
      if (upsellEl && upsellEl.dataset.upsellProductId) {
        return upsellEl.dataset.upsellProductId;
      }
  
      var upsellScript = upsellEl && upsellEl.querySelector('script[data-upsell-variants-for-kit]');
      if (upsellScript) {
        try {
          var upsellVariants = JSON.parse(upsellScript.textContent);
          for (var i = 0; i < upsellVariants.length; i++) {
            if (upsellVariants[i].featured_image && upsellVariants[i].featured_image.product_id) {
              return upsellVariants[i].featured_image.product_id;
            }
          }
        } catch (e) {}
      }
  
      return null;
    }
  
    function getProductName() {
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
        var variants = window.ShopifyAnalytics.meta.product.variants;
        if (variants && variants.length > 0 && variants[0].name) {
          var variantName = variants[0].name;
          var dashIdx = variantName.indexOf(' - ');
          return dashIdx !== -1 ? variantName.substring(0, dashIdx) : variantName;
        }
      }
      return null;
    }
  
    function normalizeValue(value) {
      return value
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_]/g, '');
    }
  
    function isColourInput(input) {
      if (!input.dataset.optionValue) return false;
      // Skip ghost inputs used for force-selection behind the scenes
      if (input.dataset.frontendHidden === 'true') return false;
      var group = input.closest('.product_variant_option');
      if (!group) return false;
      var optionName = (group.dataset.optionName || '').toLowerCase();
      return optionName === 'colour' || optionName === 'color' ||
             optionName.includes('colour') || optionName.includes('color');
    }
  
    function init() {
      document.addEventListener('change', function (e) {
        var input = e.target;
        if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return;
        if (!isColourInput(input)) return;
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'select_variant',
          variant_type: 'bottle_colour',
          variant_value: normalizeValue(input.dataset.optionValue),
          product_id: getProductId(),
          product_name: getProductName()
        });
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  
  // Leaf - Event - select_variant - End
  
  // Leaf - Event - add_to_cart_canopy_pdp - Start
  
  (function () {
    if (window.location.pathname !== '/products/restore-refillable-gel-toothpaste') return;
  
    var CURRENCY = 'GBP';
  
    function normalizeValue(value) {
      return value
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_]/g, '');
    }
  
    function getMainProduct() {
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
        return window.ShopifyAnalytics.meta.product;
      }
      return null;
    }
  
    function getMainVariantTitle(variantId) {
      var product = getMainProduct();
      if (!product || !product.variants) return null;
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(variantId)) {
          var vName = product.variants[i].name;
          if (!vName) return null;
          var dash = vName.indexOf(' - ');
          return dash !== -1 ? vName.substring(dash + 3) : vName;
        }
      }
      return null;
    }
  
    function getCanopyBottleTitle(variantId) {
      if (window.allProductUpsells) {
        for (var i = 0; i < window.allProductUpsells.length; i++) {
          if (String(window.allProductUpsells[i].id) === String(variantId)) {
            return window.allProductUpsells[i].title || null;
          }
        }
      }
      return null;
    }
  
    function isOneTimeInput(input) {
      if (input.id && input.id.endsWith('-buy_once')) return true;
      if (input.classList.contains('no-subscription-input')) return true;
      return false;
    }
  
    function isSubscribeInput(input) {
      if (input.id && input.id.endsWith('-buy_plan')) return true;
      if (input.id && /-sub$/.test(input.id) && !/-no-sub/.test(input.id)) return true;
      return false;
    }
  
    function getKitType() {
      // p_kit_component block — labelled radio with .kit-selector__title
      var kitInput = document.querySelector('input[data-kit-selection-input="true"]:checked');
      if (kitInput) {
        var label = document.querySelector('label[for="' + CSS.escape(kitInput.id) + '"]');
        var titleEl = label && label.querySelector('.kit-selector__title');
        if (titleEl && titleEl.textContent.trim()) {
          return normalizeValue(titleEl.textContent.trim());
        }
        // Fallback to data-kit-type
        return kitInput.dataset.kitType === 'product_plus_upsell' ? 'bottle_and_refills' : 'refills';
      }
      // variant-option--kit-selector snippet
      var kitOptionInput = document.querySelector('.kit-selector input[type="radio"]:checked');
      if (kitOptionInput && kitOptionInput.dataset.optionValue) {
        return normalizeValue(kitOptionInput.dataset.optionValue);
      }
      return null;
    }
  
    function getFlavourName() {
      var input = document.querySelector('.option_values.modern-flavour input[type="radio"]:checked')
        || document.querySelector('.modern-flavour__featured-wrap input[type="radio"]:checked');
      return (input && input.dataset.optionValue) ? normalizeValue(input.dataset.optionValue) : null;
    }
  
    function getPlanType() {
      var subBlock = document.querySelector('.subscription-options-block');
      if (!subBlock) return null;
      var checkedInput = subBlock.querySelector('input[type="radio"]:checked');
      if (!checkedInput) return null;
      if (isOneTimeInput(checkedInput)) return 'one_time';
      if (isSubscribeInput(checkedInput)) return 'subscribe';
      return null;
    }
  
    function getBottleColour() {
      var upsellEl = document.querySelector('[data-upsell-for-kit]');
      if (!upsellEl) return null;
      var colourInput = upsellEl.querySelector(
        '.product_variant_option[data-option-name*="olour"] input[type="radio"]:checked:not([data-frontend-hidden="true"])'
      );
      return (colourInput && colourInput.dataset.optionValue) ? colourInput.dataset.optionValue : null;
    }
  
    function getVariantSku(variantId, isBottle) {
      if (!isBottle) {
        var product = getMainProduct();
        if (product && product.variants) {
          for (var i = 0; i < product.variants.length; i++) {
            if (String(product.variants[i].id) === String(variantId) && product.variants[i].sku) {
              return product.variants[i].sku;
            }
          }
        }
      }
      var upsellEl = document.querySelector('[data-upsell-for-kit]');
      if (upsellEl) {
        var upsellScript = upsellEl.querySelector('script[data-upsell-variants-for-kit]');
        if (upsellScript) {
          try {
            var upsellVariants = JSON.parse(upsellScript.textContent);
            for (var j = 0; j < upsellVariants.length; j++) {
              if (String(upsellVariants[j].id) === String(variantId) && upsellVariants[j].sku) {
                return upsellVariants[j].sku;
              }
            }
          } catch (e) {}
        }
      }
      return variantId;
    }
  
    function buildGA4Items() {
      var items = [];
      var totalValue = 0;
      var product = getMainProduct();
      var productTitle = null;
      if (product && product.variants && product.variants.length > 0 && product.variants[0].name) {
        var pName = product.variants[0].name;
        var pDash = pName.indexOf(' - ');
        productTitle = pDash !== -1 ? pName.substring(0, pDash) : pName;
      }
  
      var selectedInputs = document.querySelectorAll('input[data-product-selection]:checked');
  
      for (var i = 0; i < selectedInputs.length; i++) {
        var input = selectedInputs[i];
        if (input.dataset.available === 'false') continue;
        if (input.hasAttribute('data-options-unselected')) continue;
        if (input.hasAttribute('data-out-of-stock')) continue;
  
        var variantId = input.value;
        var isBottle = input.dataset.upsellAtcInput === 'true';
        var priceRaw = parseInt(input.dataset.price || '0', 10);
        var quantity = parseInt(input.dataset.quantity || '1', 10);
        var price = isNaN(priceRaw) ? 0 : priceRaw / 100;
        var qty = isNaN(quantity) ? 1 : quantity;
  
        items.push({
          item_id: getVariantSku(variantId, isBottle),
          item_name: productTitle,
          item_variant: isBottle ? getBottleColour() : getMainVariantTitle(variantId),
          price: price,
          quantity: qty
        });
  
        totalValue += price * qty;
      }
  
      return { items: items, value: Math.round(totalValue * 100) / 100 };
    }
  
    function init() {
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-product-atc]');
        if (!btn) return;
        if (btn.disabled) return;
  
        var result = buildGA4Items();
        var bottleColour = getBottleColour();
  
        if (window.Shopify && window.Shopify.analytics) {
          window.Shopify.analytics.publish('leaf_prevent_atc', {});
        }
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'add_to_cart_canopy_pdp',
          ecommerce:{
            currency: CURRENCY,
            value: result.value,
            items: result.items
          },
          kit_type: getKitType(),
          flavour_name: getFlavourName(),
          plan_type: getPlanType(),
          bottle_colour: bottleColour ? normalizeValue(bottleColour) : null
        });
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  
  // Leaf - Event - add_to_cart_canopy_pdp - End
  